export default __webpack_public_path__ + "static/media/heating-central-gas-furnace-AFRW6SQ-825x340.58718eaa.jpeg";